module.exports = __webpack_public_path__ + "img/html.e9e48f20.svg";